<div class="page-section" id="about">
  <div class="section-content">
    <div class="text">
      <h2>What do we do?</h2>

      <p>
        The Card Professor takes the guesswork out of card grading. We help you
        make the best financial decisions for your collection, whether you're
        grading a rare vintage baseball card or a modern Pokémon chase card.  We
        use a proprietary 19-point inspection system—focused on centering,
        edges, surface, and corners—to determine not just if a card is worth
        grading, but which service (PSA, SGC, or Beckett) will maximize its
        final value, all while factoring in current market price trends.  We
        currently specialize in Sports Cards and Pokémon.
      </p>

      <a
        class="primary-outlined-rounded-btn"
        [href]="customerAppURLBase + '/register'">
        Get Started Now
      </a>
    </div>

    <div class="image">
      <img src="assets/images/cards.png" />
    </div>
  </div>
</div>
